import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import TAccordion from '~/components/atoms/t-accordion.vue';
import FaqAnswer from '~/components/plans/FaqAnswer.vue';

interface Props {
  faqQuestion: string;
  faqAnswer: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Faq',
  props: {
    faqQuestion: null,
    faqAnswer: null
  },
  setup(__props: any) {


const isOpen = ref(false);
const setIsOpen = (isExpanded: boolean | undefined): void => {
  isOpen.value = isExpanded || false;
};

return { __sfc: true,isOpen, setIsOpen, TAccordion, FaqAnswer }
}

})